<script setup lang="ts">
import { useFetchTransactionSummary } from '~/api/service/transaction/summary/index.service'
import TransactionsPageCharater from '~/components/@pages/transactions/[txnHash]/TransactionsPageCharater.vue'
import RouteButton from '~/components/button/RouteButton.vue'
import ListItemCard from '~/components/card/ListItemCard.vue'
import AddressCopyLink from '~/components/link/AddressCopyLink.vue'
import LoadingDashboardList from '~/components/loading/LoadingDashboardList.vue'
import { UNIT } from '~/environment-variables/unit.const'

const { data, isLoading } = useFetchTransactionSummary(10)

const getIconByType = computed(() => {
  return (type: string) => {
    if (type === 'EOA') return 'wallet'
    else if (type === 'CA') return 'file-contract'
    else return 'question-circle'
  }
})
</script>

<template>
  <div
    v-if="isLoading"
  >
    <LoadingDashboardList />
  </div>
  <div
    v-else-if="data"
    class="flex-col"
  >
    <RouteButton
      label="Latest Transaction"
      :url="routes.getTransactionsPage()"
    />

    <div class="relative">
      <TransactionsPageCharater class="transaction-character" />
      <ListItemCard
        v-for="item in data"
        :key="item"
        class="mt-2 h-[88px] p-4"
      >
        <NuxtLink
          :to="routes.getTransactionDetailPageWithTab(item.TRXHA, transactionDetailPageType.transaction)"
          class="flex h-full flex-col justify-between hover:no-underline"
        >
          <div class="top-container flex justify-between">
            <div class="flex basis-1/2 items-center gap-2 truncate">
              <FontAwesomeIcon
                class="text-primary"
                icon="exchange-alt"
                size="xs"
              />
              <NuxtLink
                class="ml-2 truncate text-lg/[1.25rem] text-primary"
                :to="routes.getTransactionDetailPageWithTab(item.transactionHash)"
              >
                <span>{{ item.transactionHash }}</span>
              </NuxtLink>
            </div>
            <div class="flex basis-1/2 items-center justify-end gap-1">
              <span class="text-lg/[0.875rem] text-primary">{{ item.value }}</span>
              <span class="text-lg/[0.875rem] text-primary/40">{{ UNIT }}</span>
            </div>
          </div>
          <div class="bottom-container flex justify-between gap-4">
            <div class="txn-from-container flex basis-[45%] items-center gap-2 truncate">
              <FontAwesomeIcon
                :icon="getIconByType(item.addressFromInfo.ADT)"
                class="text-primary opacity-40"
                size="xs"
              />
              <AddressCopyLink
                class="ml-2 truncate text-lg/[21px] text-primary/40"
                :address="item.addressFromInfo.ADDR"
              />
            </div>
            <div class="flex basis-[10%] items-center justify-center">
              <FontAwesomeIcon
                class="text-primary opacity-40"
                icon="arrow-right"
              />
            </div>
            <div class="txn-to-container flex basis-[45%] items-center gap-2 truncate">
              <FontAwesomeIcon
                :icon="getIconByType(item.addressFromInfo.ADT)"
                class="text-primary opacity-40"
                size="xs"
              />
              <AddressCopyLink
                class="ml-2 truncate text-lg/[21px] text-primary/40"
                :address="item.addressToInfo.ADDR"
              />
            </div>
          </div>
        </NuxtLink>
      </ListItemCard>
    </div>

    <button
      class="bottom-button"
      @click="$router.push(routes.getTransactionsPage())"
    >
      <div class="flex items-center justify-center gap-2">
        <span class="text-base/[1.125rem] font-bold text-white">View all transactions</span>
        <FontAwesomeIcon
          icon="chevron-right"
          color="white"
          size="xs"
        />
      </div>
    </button>
  </div>
</template>

<style scoped lang="scss">
.bottom-button {
  @apply mt-2 h-8 w-full rounded-lg bg-point-color hover:shadow-[0_16px_32px_0_rgba(92,143,250,0.2)];
}

.transaction-character {
  @apply -top-20 -right-4 hidden z-20;

  @include sm {
    @apply block;
  }
}
</style>